import { Component, Input } from "@angular/core";

@Component({
	selector: "di-menu-facturation-preparee",
	templateUrl: "./menu-facturation-preparee.component.html",
	styleUrls: ["./menu-facturation-preparee.component.scss"],
})

export class MenuFacturationPrepareeComponent  {
	@Input() public annuler: Function;

	public handleAnnuler() {
		if(this.annuler) this.annuler();
	}
}
